import log, { LogLevelDesc } from 'loglevel';
import { LOG_LEVELS, NODE_ENVIRONMENTS } from '../consts';

/**
 * check if we are in a production environment
 * @returns bool
 */
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === NODE_ENVIRONMENTS.PRODUCTION;
};

/**
 * check if we are in a development environment
 * @returns bool
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === NODE_ENVIRONMENTS.DEVELOPMENT;
};

/**
 * check if we use mock permissions
 * @returns bool
 */
export const isMockPermissions = (): boolean => {
  return isDevelopment() && process.env.REACT_APP_MOCK_PERMISSION === 'true';
};

/**
 * @returns obj with app information (to print in console)
 */
export const getAppInformation = (): AppInformation => {
  return {
    ENVIRONMENT: `${process.env.REACT_APP_VERSION} ${process.env.NODE_ENV}`,
    BASE_URL: process.env.REACT_APP_BASE_URL,
  };
};

/**
 * define log level by current environment setting.
 * if not defined - fallback is 'error' and above
 */
export const setLogLevels = (): void => {
  if (process.env.REACT_APP_LOG_LEVEL && LOG_LEVELS.includes(process.env.REACT_APP_LOG_LEVEL)) {
    log.setLevel(process.env.REACT_APP_LOG_LEVEL as LogLevelDesc);
  } else {
    log.setLevel('error');
  }
};
